import { collection, setDoc, updateDoc, getDoc, doc, serverTimestamp } from "firebase/firestore";
import { db } from '../firebase';

// Fetch game document
export const fetchGame = async (id) => {
  try {
    const docRef = doc(db, "campaign", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching document:", error);
    throw error;
  }
};

// Fetch user profile data
export const fetchUserProfile = async (userId) => {
  const docRef = doc(db, "users", userId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    console.error("No such document!");
    return null;
  }
};

// Update campaign step
export const updateCampaignStep = async (campaignId, newStep) => {
  try {
    const campaignRef = doc(db, "campaign", campaignId);
    const campaignSnap = await getDoc(campaignRef);

    if (campaignSnap.exists()) {
      const campaignData = campaignSnap.data();
      if (newStep > campaignData.step || !campaignData.step) {
        await updateDoc(campaignRef, { step: newStep });
      }
    } else {
      console.error("No such campaign document!");
    }
  } catch (error) {
    console.error("Error updating campaign step:", error);
    throw error;
  }
};

export const fetchHeadline = async (companyId) => {
  try {
    const docRef = doc(db, "workspace", companyId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      return {
        headline_url: data.headline_url || '',
        headlinePhoto: data.headlinePhoto || '',
        headline: data.headline || '',
        subheadline: data.subheadline || '',
        // Add all customization properties
        headlineFont: data.headlineFont || 'Roboto',
        subheadlineFont: data.subheadlineFont || 'Roboto',
        headlineColor: data.headlineColor || '#374151',
        subheadlineColor: data.subheadlineColor || '#6B7280',
        showIcon: data.showIcon ?? true,
        imageShape: data.imageShape || 'circle'
      };
    } else {
      console.error("No such company!");
      return null;
    }
  } catch (error) {
    console.error("Error fetching headline:", error);
    return null;
  }
};

// Save headline data to company profile
export const saveHeadline = async (companyId, headlineData) => {
  try {
    const docRef = doc(db, "workspace", companyId);
    const updateData = {
      headline_url: headlineData.headline_url || '',
      headlinePhoto: headlineData.headlinePhoto || '',
      headline: headlineData.headline || '',
      subheadline: headlineData.subheadline || '',
      headlineFont: headlineData.headlineFont || 'Roboto',
      subheadlineFont: headlineData.subheadlineFont || 'Roboto', 
      headlineColor: headlineData.headlineColor || '#374151',
      subheadlineColor: headlineData.subheadlineColor || '#6B7280',
      showIcon: headlineData.showIcon ?? true,
      imageShape: headlineData.imageShape || 'circle'
    };
    
    await updateDoc(docRef, updateData);
    return true;
  } catch (error) {
    console.error("Error saving headline:", error);
    return false;
  }
};
